import React, { Component } from "react";
import {
  TextInput,
  View,
  ScrollView,
  TouchableHighlight,
  StyleSheet,
  Dimensions,
} from "react-native";
import Text from "../components_v2/TextFont";
import FontAwesomeIcon from "../components_v2/FontAwesomeIcon";
import {
  faAngleDown,
  faAngleUp,
  faTimes,
} from "../../assets/consts/faCharCodes";
import PropTypes from "prop-types";
import { translate } from "../locales/translate";
import ModalBase from "../nativeBase-ui/ModalBase";
import { getDir, getIsRTL } from "../util";

const WINDOW_HEIGHT = Dimensions.get("window").height;

/**
 * @augments {Component<props, state>}
 */
class SearchableDropdown extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({ id: PropTypes.any, name: PropTypes.string })
    ),
    label: PropTypes.string,
    isSearchable: PropTypes.bool,
    noItemText: PropTypes.string,
    searchText: PropTypes.string,
    onSelect: PropTypes.func,
    onClear: PropTypes.func,
    style: PropTypes.shape(),
    clearable: PropTypes.bool,
    selectedValue: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.any,
    ]),
  };
  constructor(props) {
    super(props);
    let { selectedValue, items, isSearchable = true } = this.props;
    let selectedText = undefined,
      searchedText = undefined,
      _isSearchable = isSearchable;

    if (selectedValue && items) {
      for (var i in items) {
        if (items[i].id == selectedValue) {
          selectedText = items[i].name;

          // set searchedText at startup will cause a bug (list will be render empty)
          // searchedText = items[i].name;
          break;
        }
      }
    }

    this.state = {
      isMenuOpen: false,
      isSearching: false,
      isSearchable: _isSearchable,
      selectedValue,
      selectedText,
      searchedText,
    };

    this.contentRef = undefined;
    this.position = {
      x: 0,
      y: 0,
      width: "100%",
    };
  }

  handleOnItemSelect = (id, name) => {
    this.setState(
      {
        selectedValue: id,
        selectedText: name,
        searchedText: undefined,
        isMenuOpen: false,
        isSearching: false,
      },
      () => {
        this.props.onSelect && this.props.onSelect(id, name);
      }
    );
  };
  handleOnClear = () => {
    this.setState(
      {
        isMenuOpen: !this.state.isMenuOpen,
        isSearching: this.state.isSearchable && !this.state.isMenuOpen,
        selectedValue: undefined,
        selectedText: undefined,
        searchedText: undefined,
      },
      () => {
        this.props.onClear && this.props.onClear();
      }
    );
  };
  toggleMenuVisible = () => {
    if (
      this.props.clearable &&
      this.state.selectedValue &&
      !this.state.isMenuOpen
    ) {
      this.handleOnClear();
    } else {
      this.setState({
        isMenuOpen: !this.state.isMenuOpen,
        isSearching: this.state.isSearchable && !this.state.isMenuOpen,
      });
    }
  };

  renderContent = () => {
    return (
      <View
        style={this.props.style || {}}
        ref={(v) => (this.contentRef = v)}
        onLayout={() => {
          if (!this.state.isMenuOpen) {
            this.contentRef?.measureInWindow((x, y, w, h) => {
              this.position.x = x;
              this.position.y = y;
              this.position.width = w;
            });
          }
        }}
      >
        {this.props.label && (
          <Text style={styles.label}>{this.props.label}</Text>
        )}
        <View
          style={this.state.isMenuOpen ? styles.selectOpened : styles.select}
        >
          <TouchableHighlight
            style={{ paddingVertical: 6, paddingHorizontal: 6 }}
            onPress={this.toggleMenuVisible}
            underlayColor="#FFFFFF00"
          >
            <View>
              <FontAwesomeIcon
                icon={
                  this.state.isMenuOpen
                    ? faAngleUp
                    : this.props.clearable && this.state.selectedValue
                    ? faTimes
                    : faAngleDown
                }
                color="#ccc"
                size={14}
              />
            </View>
          </TouchableHighlight>
          {this.state.isSearching == false && (
            <Text
              style={{ flex: 1, height: "100%", textAlignVertical: "center" }}
              onPress={this.toggleMenuVisible}
            >
              {this.state.selectedText ||
                this.props.searchText ||
                translate("app.selectAnItem")}
            </Text>
          )}
          {this.state.isSearching == true && (
            <TextInput
              style={{ flex: 1 }}
              icon="search"
              family="font-awesome-5"
              placeholder={
                (this.state.selectedText ? `${this.state.selectedText}/` : "") +
                translate("app.search")
              }
              onChangeText={(txt) => this.setState({ searchedText: txt })}
              onTouchStart={() => this.setState({ isMenuOpen: true })}
              value={this.state.searchedText}
            />
          )}
        </View>
        {this.props.items &&
          this.props.items.length > 0 &&
          (!this.state.selectedText ||
            this.state.searchedText != this.state.selectedText) &&
          this.state.isMenuOpen && (
            <ScrollView
              style={styles.menu}
              keyboardDismissMode="interactive"
              keyboardShouldPersistTaps="handled"
            >
              <View style={{ paddingBottom: 10 }}>
                {this.props.items.map((d, i) => {
                  if (
                    !this.state.searchedText ||
                    d.name.indexOf(this.state.searchedText) >= 0
                  ) {
                    return (
                      <TouchableHighlight
                        key={d.id}
                        underlayColor="#e2e2e2"
                        style={styles.selectItem}
                        onPress={() => this.handleOnItemSelect(d.id, d.name)}
                      >
                        <Text>{d.name}</Text>
                      </TouchableHighlight>
                    );
                  }
                })}
              </View>
            </ScrollView>
          )}
        {(!this.props.items || !this.props.items.length) &&
          this.state.isMenuOpen && (
            <ScrollView style={styles.menu}>
              <Text style={{ color: "#ccc", margin: 10, textAlign: "center" }}>
                {this.props.noItemText || "---"}
              </Text>
            </ScrollView>
          )}
      </View>
    );
  };

  render() {
    if (this.state.isMenuOpen)
      return (
        <ModalBase
          avoidKeyboard={true}
          isOpen={true}
          onClose={this.toggleMenuVisible}
          contentStyle={{ height: "100%" }}
        >
          <View style={{ padding: 10, height: "100%" }}>
            {this.renderContent()}
          </View>
        </ModalBase>
      );
    else return this.renderContent();
  }
}

const selectStyle = {
  width: "100%",
  height: 38,
  backgroundColor: "#FFF",
  borderColor: "#7d7e80",
  borderTopLeftRadius: 7,
  borderTopRightRadius: 7,
  borderWidth: 1,
  borderBottomWidth: 0,
  alignSelf: "center",
  marginBottom: 0,
  paddingHorizontal: 10,
  flexDirection: "row",
  alignItems: "center",
};

const styles = StyleSheet.create({
  label: {
    marginStart: 10,
    marginVertical: 10,
    fontSize: 14,
  },
  select: { ...selectStyle, borderRadius: 7, borderBottomWidth: 1 },
  selectOpened: { ...selectStyle },
  selectItem: {
    padding: 10,
    marginVertical: 5,
    backgroundColor: "#ddd",
    borderColor: "#bbb",
    borderWidth: 1,
    borderRadius: 5,
  },
  menu: {
    maxHeight: WINDOW_HEIGHT / 1.6,
    borderColor: "#ADB5BD",
    backgroundColor: "#f5f7fa",
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomLeftRadius: 7,
    borderBottomRightRadius: 7,
    width: "100%",
    alignSelf: "center",
    padding: 10,
    marginTop: 0,
  },
});

export default SearchableDropdown;
